import ChooseTemplateModal from './ChooseTemplateModal.component';

export default ChooseTemplateModal;
